
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlG as ObiOwnShipControlGElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-g.js';
 
 
 

 
 export const ObiOwnShipControlG = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-g',
   elementClass: ObiOwnShipControlGElement,
   events: {
     
   }
  });
 
 